export const PROJECT_SCOPE_TYPES = {
    LOCAL: 'Local',
    GLOBAL: 'Global'
};

export const getScopeName = (scope) => {
    switch (scope) {
        case PROJECT_SCOPE_TYPES.LOCAL:
            return 'Local';
        case PROJECT_SCOPE_TYPES.GLOBAL:
            return 'Global';
        default:
            return scope;
    }
};

export const getScopeBackgroundColor = (scope) => {
    switch (scope) {
        case PROJECT_SCOPE_TYPES.LOCAL:
            return '#FEF3E2';
        case PROJECT_SCOPE_TYPES.GLOBAL:
            return '#E0E7FF';
        default:
            return '#F3F4F6';
    }
};

export const getScopeTextColor = (scope) => {
    switch (scope) {
        case PROJECT_SCOPE_TYPES.LOCAL:
            return '#D97706';
        case PROJECT_SCOPE_TYPES.GLOBAL:
            return '#4F46E5';
        default:
            return '#6B7280';
    }
};